import React, { ElementType } from 'react';
import { Box } from '@mui/material';
import { alpha, useColorScheme } from '@mui/material/styles';

interface IDictIconBadgeProps {
  Icon: ElementType;
  accent: string;
  size?: number;
  radius?: number;
}

const DictIconBadge: React.FC<IDictIconBadgeProps> = ({
  Icon,
  accent,
  size = 48,
  radius = 12,
}) => {
  const { mode } = useColorScheme();
  const tintAlpha = mode === 'dark' ? 0.2 : 0.12;
  return (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: alpha(accent, tintAlpha),
        borderRadius: `${radius}px`,
        color: accent,
        display: 'inline-flex',
        flex: 'none',
        height: size,
        justifyContent: 'center',
        width: size,
      }}
    >
      <Icon sx={{ fontSize: Math.round(size * 0.52) }} />
    </Box>
  );
};

export default DictIconBadge;
